export default {
  liteVersion: {},
  header: {},
  modalTitle: {},
  content: {},
  first: {},
  contentModule: {},
  contentModuleRow: {},
  contentModuleCell: {},
  contentModuleCellPrice: {},
  contentModuleCellPriceInfo: {},
  hotelInfoHeader: {},
  hotelTitle: {},
  short: {},
  large: {},
  finalPrice: {},
  last: {},
  penaltiesContainer:{},
  hotelFiscalInfoContainer: {
    display: "flex",
    flexDirection: "column",
    textAlign: "right"
  },
  penaltiesContent:{},
  penaltiesTitle:{},
  penaltiesText:{},
  starDiscount:{},
  pendingConfirmationStyle:{
  },
  defaultStyle: {
    background: '#fff',
    '& $liteVersion': {
      background: '#f1f1f1'
    },
    '&:lang(ar)': {
      direction: "rtl"
    },
    '& $header': {
      position: 'relative',
      display: 'block',
      padding: '11px 20px 14px 20px',
      '&:after': {
        content: "''",
        position: 'absolute',
        left: '30px',
        right: '30px',
        bottom: '0',
        borderBottom: '1px solid #d8d8d8',
        '@media (max-width: 900px)': {
          left: '20px',
          right: '20px',
        }
      },
      '& $modalTitle': {
        font: "18px 'Droid Serif'",
        '@media (min-width: 901px)': {
          fontSize: '24px'
        }
      },
      '@media (min-width: 901px)': {
        padding: '20px 30px 15px'
      }
    },
    '& $content': {
      paddingBottom: '20px',
      '&:lang(ar)': {
        '& $short': {
          '& $contentModuleRow': {
            '&:last-of-type': {
              '& $contentModuleCell': {
                '&$large':{
                  '& > span':{
                    display: 'flex',
                    alignItems: 'center',
                    '& span':{
                      marginLeft: '4px',
                      '&:last-of-type':{
                        display: 'flex',
                        alignItems: 'center',
                      }
                    }
                  }
                },
              }
            }
          }
        }
      },
      '& $contentModuleRow:not(:first-of-type)': {
        '& $contentModuleCell': {
          paddingTop: '10px'
        }
      },
      '& $contentModule': {
        '&$first': {
          padding: '0',
          position: 'relative',
          '& $hotelInfoHeader': {
            padding: '10px 20px 6px',
            '& $hotelTitle': {
              font: "500 16px 'Roboto'",
              display: 'block',
              '@media (min-width: 801px)': {
                fontSize: '24px',
                fontWeight: 'normal'
              }
            },
            '@media (min-width: 801px)': {
              padding: '10px 20px 13px'
            },
            '@media (min-width: 901px)': {
              //padding: '10px 30px 13px'
              padding: '15px 30px'
            }
          },
          '@global > button': {
            margin: '0 20px'
          },
          '&:after': {
            content: "''",
            position: 'absolute',
            left: '20px',
            right: '20px',
            bottom: '0',
            borderBottom: '1px solid #d8d8d8',
            '@media (min-width: 901px)': {
              left: '30px',
              right: '30px'
            }
          }
        },
        padding: '15px 20px',
        display: 'table',
        '&$contentFlex':{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          '&$taxInfoModule':{
            gap: '5px',
          },
          '& $contentFlexRow':{
            display: 'flex',
          },
          '& $contentFlexCell':{
            '&$flexCellFullWidth':{
              width: '100%',
              textAlign: 'end',
              '&$alignLeft':{
                textAlign: 'start',
              }
            },
          }
        },
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        '& $contentModuleRow': {
          display: 'table-row',
          '& $contentModuleCell': {
            display: 'table-cell',
            width: '50%',
            '&$nameExtra':{
              width: '70%',
            },
            '&$short': {
              width: '35%'
            },
            '&$large': {
              width: '65%'
            },
            '&$cityTaxInfo':{
              width: '100%'
            }
          },
          '& $contentModuleCellPrice': {
            textAlign: 'right',
            '&:lang(ar)': {
              textAlign: "left"
            }
          },
        },
        '@media (min-width: 901px)': {
          padding: '15px 30px'
        },
        '&$contentModuleCellPriceInfo': {
          '& $contentModuleRow': {
            '& $contentModuleCell': {
              padding: '0 0 7px',
              '&$promoCell':{
                paddingTop: '20px',
              },
              '&$taxesCell':{
                paddingTop: '10px',
                marginTop: 'unset'
              },
              '&:not(:first-of-type)': {
                maxWidth: '200px',
                wordBreak: 'break-word',
                paddingTop: 0
              },
              '& $starDiscount':{
                maxWidth: '140px'
              }
            },
            '&:after': {
              position: 'absolute',
              borderBottom: '1px solid #d8d8d8',
              left: '20px',
              right: '20px',
              content: "''",
              bottom: '0',
              '@media (min-width: 901px)': {
                left: '30px',
                right: '30px'
              }
            }
          }
        },
        '&:not(:first-of-type):not($noBorderBottom):before': {
          content: "''",
          position: 'absolute',
          left: '20px',
          right: '20px',
          bottom: '0',
          borderBottom: '1px solid #d8d8d8',
          '@media (min-width: 901px)': {
            left: '30px',
            right: '30px'
          }
        },
        '&$finalPrice': {
          '& $contentModuleRow': {
            '& $contentModuleCell': {
              paddingTop: '0'
            }
          }
        },
        '&$last': {
          border: 'none',
          '&:before': {
            content: 'none'
          },
          '& $penaltiesContainer':{
            paddingTop:'20px',
            '& $penaltiesContent':{
              backgroundColor:'#ffecccbf',
              padding:'15px 10px',
              '& $penaltiesTitle':{
                color: data => data.mainColor,
                font: data => '700 11px ' + data.fontFamily1,
                display:'block'
              },
              '& $penaltiesText':{
                font: data => '400 11px ' + data.fontFamily1,
                color: '#000'
              }
            }
          }
        },
      },
    },
    '&$pendingConfirmationStyle':{
      border:'1px solid #d8d8d8',
      '& $header':{
        '& $modalTitle': {
          font: "22px 'Droid Serif'",
          '@media (min-width: 901px)': {
            fontSize: '24px'
          }
        },
      },
      '& $content': {
        '& $contentModule': {
          '&$first': {
            '& $hotelInfoHeader': {
              paddingTop:'15px'
            }
          },
          '&$last': {
            padding:'18px 0 0',
            '& > span':{
              display:'block',
              padding:'0 30px'
            },
            '& $penaltiesContainer':{
              padding:'20px 0 0',
              '& $penaltiesContent':{
                padding:'15px 30px 20px',
                background:'#f0efe9'
              }
            }
          }
        }
      },
    },
  },
  hide: {
    display: 'none'
  },
  confirmationSummary: {
    //background: '#f1f1f1',
    '@media (min-width: 801px)': {
      //border: '1px solid #d8d8d8'
    }
  },
  summaryModal: {
    '& $header': {
      position:'sticky',
      top:0,
      backgroundColor:'#fff',
      zIndex:1
    }
  },
  noBorder:{
    '&:before':{
      borderBottom:'none !important'
    }
  },
  discountLoyalty: {
    'display': 'flex',
    'gap': '5px'
  },
  configStay:{
    marginLeft: '23px'
  },
  fontWeight300:{
    fontWeight: '300',
  },
  loyaltyPrice:{},
  discountPrice:{},
  taxes:{
    fontWeight: '400',
  },
  bold:{},
  priceNumbers:{
    font: "300 13px 'Roboto', sans-serif",
    color: '#666',
    '&$loyaltyPrice':{
      color: data => data.mainColor,
    },
    '&$discountPrice':{
      fontWeight: '500',
      fontSize: '15px',
      '&:not($loyaltyPrice)':{
        color: '#5ca70a'
      }
    },
    '&$taxes':{
      fontWeight: '400',
    },
    '&$bold':{
      fontWeight: 'bold'
    }
  },
  noBorderBottom:{},
  contentFlexRow:{},
  contentFlexCell:{},
  flexCellFullWidth:{},
  contentFlex:{},
  paymentInfo:{
    font: "400 16px 'Roboto', sans-serif",
    color: '#666',
  },
  promoCell:{},
  taxesCell:{
    //marginTop: '20px'
  },
  taxesTitle:{
    '@media (min-width: 901px)': {
      fontSize: '15px'
    }
  },
  cityTaxInfo:{
    width: '100%',
  },
  taxInfoModule: {
    '& $contentModuleRow':{
      '&$contentFlexRow':{
        '& $contentModuleCell':{
          '&$contentFlexCell':{
            padding: '0',
          }
        }
      },
    }
  },
  penaltiesBlock: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    background: '#F1F2EF',
    gap: '5px',
    '@media (max-width: 900px)': {
      padding: '15px 20px',
    },
    '& $penaltiesText': {
      lineHeight: '1.5',
    }
  },
  taxInfoBlock: {
    '& > div':{
      '&:last-of-type': {
        marginBottom: '20px',
      }
    }
  },
  alignLeft:{},
  gray:{
    color: '#666'
  },
  nameExtra:{},
  stDefault: {
    fill: data => data.STdefaultTier,
    color: data => data.STdefaultTier,
    borderColor: data => data.STdefaultTier,
  },
  availMainSideSummaryHeader: {
    position: 'sticky',
    top: '0',
    background: '#fff',
    zIndex: 1,
    display: 'flex',
    padding: '20px 30px 15px'
  },
  availMainSideSummaryHotel: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    gap: '15px',
  },
  availMainSideSummaryReservation: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
  },
  summaryBookingBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    gap: '20px',
  },
  availPaymentBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    gap: '20px',
  },
  removeGap: {
    gap: '0',
  },
  noGapBottom: {
    marginBottom: '-20 !important',
  },
  availMainSideSummaryLoyaltyPoints: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    gap: '20px',
  },
  availMainSideSummaryTaxes: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    gap: '10px'
  },
  removePaddingBottom: {
    paddingBottom: '0'
  },
  availMainSideSummaryHotelInfo: {
    display: 'flex',
    padding: '15px 30px',
    flexDirection: 'column',
    textAlign: 'right',
    lineHeight: '0.5'
  },
  availMainSideSummaryPenalties: {
    '& > div > div': {
      padding: '15px 30px',
    }
  },
  separator: {
    margin: '0 30px',
    content: "''",
    borderBottom: '1px solid #d8d8d8',
  }
};
